import { render, staticRenderFns } from "./SeasonRouteTable.vue?vue&type=template&id=830a848c"
import script from "./SeasonRouteTable.vue?vue&type=script&lang=js"
export * from "./SeasonRouteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports